import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
// core components
import GridItem from '@/components/Grid/GridItem';
import GridContainer from '@/components/Grid/GridContainer';
import CustomInput from '@/components/CustomInput/CustomInput';
import Button from '@/components/CustomButtons/Button';
import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';
import logoimg from '@/assets/img/imgpsh_fullsize_anim_front.png';
import { API_BASE_URL } from '../../config';
import FloatingLanguagePicker from '@/components/LanguagePicker/FloatingLanguagePicker';
import PoweredByTailfin from '@/components/PoweredByTailfin';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ email: '' });
  const [redirect, setRedirect] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  // TODO: refactor to not use this
  const [successMsg] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const forgotPassword = () => {
    const email = form.email.trim();
    const formData = new FormData();
    formData.append('email', email);
    localStorage.setItem('forgotEmail', email);

    axios
      .post(API_BASE_URL + '/forgot_password', formData)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.redirect) {
            setRedirect(true);
          }
        }
        setErrorMsg(response.data.msg);
      })
      .catch((err) => {
        setErrorMsg(err.response?.data?.msg || 'An error occurred');
      });
  };

  if (redirect) {
    navigate('/user/resetpassword');
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          forgotPassword();
        }}>
        <GridContainer style={{ justifyContent: 'center' }}>
          <GridItem xs={8} sm={8} md={6}>
            <Card>
              <CardHeader color='primary'>
                <GridContainer alignItems='center' justify='space-between'>
                  <GridItem xs={8} sm={8} md={6}>
                    <h4>{t('auth.forgotPassword.title')}</h4>
                  </GridItem>
                  <GridItem xs={8} sm={8} md={6}>
                    <img src={logoimg} width='130' alt='Logo' />
                  </GridItem>
                </GridContainer>{' '}
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {successMsg ? (
                    <GridItem xs={8} sm={8} md={6}>
                      <p style={{ color: 'green' }}>{successMsg}</p>
                    </GridItem>
                  ) : errorMsg ? (
                    <GridItem xs={8} sm={8} md={6}>
                      <p style={{ color: 'red' }}>{errorMsg}</p>
                    </GridItem>
                  ) : null}
                </GridContainer>
                <GridContainer>
                  <GridItem xs={8} sm={8} md={12}>
                    <CustomInput
                      labelText={t('auth.forgotPassword.emailLabel')}
                      id='email'
                      name='email'
                      onChange={handleInputChange}
                      value={form.email}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                      required
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer alignItems='center'>
                  <GridItem xs={8} sm={8} md={6}>
                    <Button color='primary' type='submit'>
                      {t('auth.forgotPassword.submitButton')}
                    </Button>
                  </GridItem>
                  <GridItem xs={8} sm={8} md={6}>
                    <Link color='primary' to='/user/Facilitylogin'>
                      {t('auth.forgotPassword.backToLoginLink')}
                    </Link>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </form>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}>
        <PoweredByTailfin size='medium' />
      </div>

      <FloatingLanguagePicker />
    </div>
  );
};

export default ForgotPassword;
